import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt } from 'react-icons/fa';
import '../../../assets/css/customer/home/Herosection.css';

const Herosection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <Container fluid className="hero-container">
        <Row className="align-items-center hero-row">

          {/* Left Side - Image */}
          <Col lg={6} md={12} className="hero-image-col">
            <div className="hero-image-wrapper">
              <div className="couple-image-container">
                <img
                  src="https://i.pinimg.com/1200x/62/21/38/62213830e5feead437ff98b6678f70b9.jpg"
                  alt="Happy Wedding Couple"
                  className="couple-image"
                />
              </div>
            </div>
          </Col>

          {/* Right Side - Content */}
          <Col lg={6} md={12} className="hero-content-col">
            <div className="hero-content">

              {/* ✅ Rings icon & animation removed */}

              {/* Main Heading */}
              <h1 className="hero-heading">
                Perfect Weddings<br />
                Made Easy!
              </h1>

              {/* Description */}
              <p className="hero-description">
                Experience elegant wedding planning with smart tools, seamless booking, and personalized recommendations
              </p>

              {/* CTA Button */}
              <button className="btn-reservation" onClick={() => navigate('/customer/login')}>
                <FaCalendarAlt className="btn-icon" />
                Make Reservations
              </button>

            </div>
          </Col>
        </Row>
      </Container>

      {/* Bottom decorative text */}
      <div className="bottom-decoration">
        <span className="decorative-text"></span>
      </div>
    </section>
  );
};

export default Herosection;